import { ARGENTINA, BRAZIL } from 'constants/contacts'
import type { ContactFormKeys } from '../schemas/contactSchema'
import ukraineRegionsData from './ukraine-regions.json'

export const ukraineRegionOptions = ukraineRegionsData

export const FIAT_SECTION_FIELDS: ContactFormKeys[] = [
  'companyRegistrationNumber',
  'companyRegistrationCountry',
  'addressLine1',
  'addressLine2',
  'city',
  'postCode',
  'region',
  'regionCode',
  'countryOfResidence',
  'dateOfBirth',
]

export const MAX_GOVERNMENT_IDS = 2

export const GOVERNMENT_ID_COUNTRIES = [
  { value: ARGENTINA, labelKey: 'contacts.governmentIds.argentina' },
  { value: BRAZIL, labelKey: 'contacts.governmentIds.brazil' },
] as const
